import { locales } from '../locales';

const DE_TO_KEY = {
  "📦 Paketshop / Kiosk": "k001",
  "🇳🇱 Pakketpunt (NL / International)": "k002",
  "🏢 Büro / Empfang / Co-Working": "k003",
  "🏠 Wohnanlage / Wohnheim / Hotel": "k004",
  "🧥 Gepäck / Garderobe / Fundbüro / Werkstatt": "k005",
  "🛍️ Click & Collect / Abholtheke / Reparatur": "k006",
  "Benachrichtigung, Ausgabe & Datenschutz": "k007",
  "Lege fest, ob Empfänger automatisch per E-Mail benachrichtigt werden, bei der Abholung unterschreiben oder Datenschutzbedingungen bestätigen.": "k008",
  "Was bist du? (Einsatzbereich wählen)": "k009",
  "Aktiviert automatisch die passenden Funktionen für deinen Bereich. Du kannst in den nächsten Schritten alles feinjustieren.": "k010",
  "📦 Paketshop / Kiosk (DE)": "k011",
  "Sortierung nach Hausnummer, PLZ-Kreis-Prüfung, Paketdienste & 5 Tage Löschfrist.": "k012",
  "🇳🇱 Pakketpunt / Abholpunkt (NL / International)": "k013",
  "Sortierung nach Nachname (A–Z), Serienmodus, Vinted-Unterstützung.": "k014",
  "🏢 Büro / Empfang / Co-Working (Interne Poststelle)": "k015",
  "Mitarbeiter-Adressbuch (CSV-Import für Microsoft/Google), Auto-E-Mail beim Scannen & Unterschrift bei Ausgabe.": "k016",
  "🏠 Wohnanlage / Studentenwohnheim / Hotel / Camping": "k017",
  "Bewohner-Adressbuch mit Auto-E-Mail-Benachrichtigung & Tablet-Suchmodus für Abholer.": "k018",
  "🧥 Gepäckannahme / Garderobe / Fundbüro / Werkstatt": "k019",
  "Für Gegenstände ohne Namen: Auto-Nummerierung (#001) oder Ausweis zuerst, 2. Kunden-Abholbon, Datenschutz-Einwilligung & kurze Speicherfrist.": "k020",
  "🛍️ Click & Collect / Abholtheke / Reparatur & Reinigung": "k021",
  "Für Laden-Bestellungen, Apotheken, Werkstätten & Textilreinigung: Kunden-Adressbuch, Auto-E-Mail mit Abhol-PIN, Laufnummer (#001), 2. Abholbon & Unterschrift.": "k022",
  "Für diesen Einsatzbereich werden meist keine Paketdienste benötigt — du kannst direkt auf „Weiter\" tippen.": "k023",
  "Standard-Sortierung (gilt für alle Paketdienste)": "k024",
  "Pro Paketdienst abweichend sortieren (optional)": "k025",
  "Nur gewählte Dienste": "k026",
  "Alle Dienste zeigen": "k027",
  "Standardmäßig gilt die obige Einstellung für alle Dienste. Hier kannst du einzelne Paketdienste gezielt anders sortieren (z. B. PostNL nach Hausnummer, DHL nach Nachname, Vinted nach Kurznummer). Wird im Konto-Profil gespeichert.": "k028",
  "Wie Standard": "k029",
  "🏠 Hausnr.": "k030",
  "🔤 A–Z": "k031",
  "🔢 Kurznr.": "k032",
  "🎟️ Zweites Etikett als Kunden-Abholbon drucken": "k033",
  "Druckt nach dem Paket-/Gepäcketikett ein zweites Etikett zum Abreißen als Abholschein für den Kunden.": "k034",
  "🚚 Paketdienst in der Paketliste anzeigen": "k035",
  "Zeigt bei jedem Paket in der Liste den Paketdienst (DHL, PostNL, Vinted …) neben dem Fach.": "k036",
  "🔢 Automatische Laufnummer (#001, #002…) ohne Namen": "k037",
  "Ideal für Gepäck, Garderobe, Fundbüro oder Reparatur: Steht kein Name auf dem Gegenstand, vergibt die App automatisch eine fortlaufende Nummer.": "k038",
  "🪪 „Ausweis zuerst\" beim Erfassen anbieten / nutzen": "k039",
  "Liest den Namen beim Erfassen direkt vom Personalausweis, Reisepass oder Führerschein des Kunden ab.": "k040",
  "📒 Empfänger- / Stammkunden-Liste (CSV & Kontakte) anzeigen": "k041",
  "Bei Paketshop standardmäßig aus: Schalte dies ein, wenn du eine Liste (z. B. Stammkunden mit Hinterlegungs-Notiz/Stammfach, eigene Shop-Mitarbeiter oder Büro/Wohnanlage) anlegen möchtest.": "k042",
  "Empfänger- & Stammkunden-Liste verwalten": "k043",
  "Trage Stammkunden, Mitarbeiter oder Bewohner einzeln ein oder importiere sie per CSV (inkl. Stammfach & speziellem Hinweis für Mitarbeiter beim Scannen/Ausgeben).": "k044",
  "Beispiel-CSV": "k045",
  "Was soll passieren, wenn ein Paket für jemanden auf der Liste gescannt wird?": "k046",
  "👷 (a) Nur Mitarbeiter am Bildschirm informieren (ohne E-Mail)": "k047",
  "Ideal für Stammkunden & eigene Mitarbeiter im Paketshop: Zeigt beim Scannen & Ausgeben sofort einen auffälligen Hinweis am Gerät (z. B. „Auf Liste!\", Hinterlegungs-Notiz, Stammfach).": "k048",
  "💬 (b) Mitarbeiter informieren & fragen, ob E-Mail rausgehen soll": "k049",
  "Zeigt den Hinweis beim Scannen und öffnet nach dem Speichern ein Fenster, in dem der Mitarbeiter per Tipp entscheiden kann, ob der Kunde per E-Mail benachrichtigt wird.": "k050",
  "📧 (c) Mitarbeiter informieren + vollautomatisch E-Mail senden": "k051",
  "Zeigt dem Mitarbeiter Notiz & Stammfach und sendet beim Speichern sofort automatisch eine Abhol-E-Mail an die hinterlegte E-Mail-Adresse.": "k052",
  "📧 Automatische E-Mail bei Wartelisten-Treffer (🔔 QR-Code)": "k053",
  "Wenn sich ein Kunde über den 🔔 Benachrichtigungs-Button (QR-Code) eingetragen hat, sendet die App beim Scannen seines Pakets sofort automatisch die Abhol-E-Mail (sonst wird vorher gefragt).": "k054",
  "✍️ Unterschrift bei Ausgabe verlangen": "k055",
  "Beim Ausgeben unterschreibt der Empfänger mit Finger oder Stift direkt auf dem Bildschirm.": "k056",
  "📱 Tablet-Suchmodus (Kunden-Suchterminal)": "k057",
  "Blendet den Tablet-Suchmodus in der Hauptansicht ein, damit Abholer ihren Namen am Tablet eingeben und sich für E-Mail-Benachrichtigungen eintragen können.": "k058",
  "🛡️ Eigene Datenschutzverordnung / Einwilligung vor Speichern": "k059",
  "Besonders wichtig bei Ausweis-Fotos: Der Kunde bestätigt vor dem Speichern deine Datenschutzerklärung auf dem Bildschirm.": "k060",
  "Dein Datenschutz-/Einwilligungstext (für den Kunden sichtbar):": "k061",
  "Speicherfrist nach Ausgabe (Auto-Löschung)": "k062",
  "Wie lange sollen ausgegebene Pakete/Gepäckstücke (inkl. Fotos) noch im Verlauf bleiben, bevor sie endgültig gelöscht werden?": "k063",
  "Einsatzbereich": "k064",
  "2. Kunden-Abholbon": "k065",
  "Paketdienst in der Liste": "k066",
  "Laufnummer #001": "k067",
  "Ausweis zuerst": "k068",
  "Ausgabe & Datenschutz": "k069",
  "Auto-E-Mail (Warteliste)": "k070",
  "Unterschrift": "k071",
  "Tablet-Modus": "k072",
  "Datenschutz-Bestätigung": "k073",
  "Löschfrist": "k074",
  "Paket": "k075",
  "Pakete": "k076",
  "📋 Barcode-Stapel deaktiviert. Du kannst ihn jederzeit über das Setup (Einstellungen → Setup starten) wieder einschalten.": "k077",
  "Aktueller Stapel": "k078",
  "Paketliste": "k079",
  "Alle Stapel": "k080",
  "Berechtigung erneut anfragen": "k081",
  "App-Berechtigungen öffnen": "k082",
  "Piep erkannt → Nächstes Paket!": "k083",
  "Aktuelle Lieferung": "k084",
  "Pakete innerhalb von 15 Min. landen im selben Stapel · Neuere Lieferung startet automatisch bei 1": "k085",
  "Boten-Anzahl (optional)": "k086",
  "Ganzen Stapel als erledigt markieren": "k087",
  "Wie viele Pakete hat der Bote gebracht?": "k088",
  "z. B. 30": "k089",
  "Speichern": "k090",
  "Zurücksetzen": "k091",
  "Aktuell ist kein offener Barcode-Stapel aktiv": "k092",
  "Sobald du neue Pakete fotografierst, startet hier automatisch ein frischer Stapel bei Paket 1.": "k093",
  "Wozu ist der Barcode-Stapel da?": "k094",
  "Beim Fotografieren deiner Pakete speichert PaketPilot die echten Etikett-Barcodes im Hintergrund mit. Nach einer Lieferung kannst du hier alle Barcodes nacheinander groß auf dem Display abspielen und bequem am Stück mit dem DHL-/Kurier-Scanner abscannen (z. B. für die DHL-Schnelleinlagerung), ohne jedes Paket erneut in die Hand zu nehmen.": "k095",
  "Barcode-Stapel nicht mehr anzeigen (kann über Setup wieder geändert werden)": "k096",
  "Letzten Stapel wieder öffnen": "k097",
  "Alle Lieferungen & Stapel der letzten 7 Tage": "k098",
  "Warum gibt es den Barcode-Stapel?": "k099",
  "Beim Erfassen speichert PaketPilot automatisch die Etikett-Barcodes deiner Pakete. Nach einer Kurierlieferung kannst du hier alle Barcodes nacheinander groß auf dem Bildschirm abspielen und direkt am Stück mit dem Zusteller-Scanner (z. B. DHL-Handscanner) abscannen — ohne jedes Paket noch einmal anfassen zu müssen.": "k100",
  "Barcode-Stapel nicht mehr anzeigen (über Setup wieder änderbar)": "k101",
  "Stapel abschließen & archivieren": "k102",
  "Nochmal von vorn": "k103",
  "Soll Bote": "k104",
  "Bereits gescannt": "k105",
  "Noch offen — jetzt scannen": "k106",
  "Offen setzen": "k107",
  "Zuletzt davor erledigt:": "k108",
  "Lädt…": "k109",
  "Originalfoto (zoombar)": "k110",
  "Auf diesem Etikett wurden mehrere Barcodes erkannt (z. B. Strichcode + QR/DataMatrix). Hiermit schaltest du um.": "k111",
  "Letztes Paket als gescannt markieren": "k112",
  "Pausieren — zeigt beim nächsten Öffnen genau dieses Paket wieder an": "k113",
  "Automatisches Abdunkeln deaktiviert": "k114",
  "DHL-Scanner-Piep schaltet automatisch weiter": "k115",
  "gescannt": "k116",
  "Tag": "k117",
  "Von": "k118",
  "Bis": "k119",
  "Lieferungen mit mehr als 15 Minuten Abstand werden automatisch als eigener Stapel angelegt. Du kannst jeden Stapel einzeln öffnen oder direkt als ✅ Erledigt markieren.": "k120",
  "Aktuell": "k121",
  "Weiter scannen": "k122",
  "Als erledigt markieren": "k123",
  "Erledigt": "k124",
  "Mit dem aktuellen Stapel zu einem gemeinsamen Stapel verbinden": "k125",
  "Verbinden": "k126",
  "Wieder öffnen": "k127",
  "Stapel öffnen": "k128",
  "Weitere Lieferungen aus dem Paketbestand (nach 15-Min.-Abstand gruppiert):": "k129",
  "Als Stapel öffnen": "k130",
  "Keine früheren Stapel für diesen Zeitraum gefunden.": "k131",
  "Zurück zum aktuellen Stapel": "k132",
  "Pause / Schließen": "k133",
  "Änderungen gespeichert ✓": "k134",
  "Kontakt gespeichert ✓": "k135",
  "Keine gültigen Kontakte in der CSV-Datei gefunden. Bitte prüfe die Spalten (Name, E-Mail).": "k136",
  "Fehler beim Lesen der CSV-Datei.": "k137",
  "Empfänger- & Stammkunden-Liste (CSV)": "k138",
  "CSV-Liste importieren (Stammkunden / Mitarbeiter / Bewohner)": "k139",
  "Lade unsere Beispiel-CSV herunter (enthält Spalten für Name, E-Mail, Adresse/Abteilung, Stammfach & Hinweis für Mitarbeiter) oder importiere direkt aus Excel, Microsoft Outlook/365 oder Google Kontakte.": "k140",
  "CSV-Datei auswählen…": "k141",
  "Beispiel-CSV herunterladen": "k142",
  "Eintrag bearbeiten": "k143",
  "Empfänger / Stammkunde hinzufügen": "k144",
  "Abbrechen": "k145",
  "Vor- und Nachname *": "k146",
  "E-Mail (optional)": "k147",
  "Straße / Abt. / Raum": "k148",
  "Stammfach (z.B. S1)": "k149",
  "📌 Hinweis für Mitarbeiter (z.B. Stammkunde – legt immer in Fach S1 / Hinterlegungswunsch)": "k150",
  "Hinzufügen": "k151",
  "🔍 Liste durchsuchen (Name, Hinweis, Fach, E-Mail)…": "k152",
  "Alle löschen": "k153",
  "Noch keine Einträge auf der Liste. Lade oben eine CSV hoch oder füge jemanden hinzu.": "k154",
  "Keine Treffer für diese Suche.": "k155",
  "Kein E-Mail/Abteilungs-Eintrag (nur Mitarbeiter-Hinweis)": "k156",
  "Bearbeiten": "k157",
  "Löschen": "k158",
  "Fertig": "k159",
  "Bitte Vor- und Nachnamen eingeben.": "k160",
  "Bitte eine gültige E-Mail-Adresse eingeben.": "k161",
  "✅ Kunde wurde eingetragen! Sobald das Paket gescannt wird, erfolgt die E-Mail-Benachrichtigung.": "k162",
  "Fehler beim Speichern.": "k163",
  "Paket noch nicht da?": "k164",
  "QR-Code mit dem Handy scannen": "k165",
  "und Name & E-Mail eintragen.<br/>Sie erhalten automatisch eine E-Mail, sobald Ihr Paket bei uns eintrifft!": "k166",
  "Jetzt drucken": "k167",
  "Paket-Benachrichtigung": "k168",
  "Kunden per E-Mail informieren, sobald ihr Paket gescannt wird": "k169",
  "📱 QR-Code (Kunde)": "k170",
  "✍️ Direkt eintragen": "k171",
  "Wartend": "k172",
  "📱 Kunde scannt mit eigenem Smartphone": "k173",
  "Der Kunde gibt seinen Namen, Straße und E-Mail selbst auf dem Handy ein — du musst nichts abtippen!": "k174",
  "⏳ QR-Code wird geladen…": "k175",
  "⚠️ Bitte online anmelden, um deinen Shop-QR-Code zu erzeugen.": "k176",
  "Aufsteller drucken": "k177",
  "✅ Link kopiert!": "k178",
  "🔗 Link kopieren": "k179",
  "⚡ E-Mail beim Paket-Scan sofort automatisch senden": "k180",
  "Aktiv: Sobald du ein passendes Paket speicherst, geht die E-Mail ohne Rückfrage raus.": "k181",
  "Aus: Beim Speichern eines passenden Pakets fragt die App kurz nach, ob die Mail gesendet werden soll.": "k182",
  "z. B. Max Mustermann": "k183",
  "E-Mail-Adresse *": "k184",
  "kunde@beispiel.de": "k185",
  "Straße & Hausnummer (optional)": "k186",
  "z. B. Hauptstraße 12": "k187",
  "Notiz / Sendungsnr. (optional)": "k188",
  "z. B. Express / Retoure": "k189",
  "⏳ Wird gespeichert…": "k190",
  "🔔 Benachrichtigung speichern": "k191",
  "⏳ Lade Warteliste…": "k192",
  "Aktuell warten keine Kunden auf eine Paket-Benachrichtigung.": "k193",
  "✅ Benachrichtigt": "k194",
  "⏳ Wartet": "k195",
  "Eintrag entfernen": "k196",
  "Unterschrift bei Ausgabe": "k197",
  "Fach": "k198",
  "Abgeholt von (optional, falls abweichend)": "k199",
  "Hier mit Finger oder Stift unterschreiben": "k200",
  "Ohne Unterschrift": "k201",
  "Bestätigen & Ausgeben": "k202",
  "Bitte gib eine Nachricht oder dein Feedback ein.": "k203",
  "Fehler beim Senden. Bitte versuche es erneut.": "k204",
  "💡 Wunsch / Idee": "k205",
  "🐛 Problem melden": "k206",
  "❓ Frage / Kontakt": "k207",
  "Feedback, Wünsche & direkter Kontakt": "k208",
  "Schreib uns direkt hier aus der App — deine Nachricht landet sofort bei uns per E-Mail.": "k209",
  "Vielen Dank! Deine Nachricht wurde gesendet.": "k210",
  "Wir haben dein Feedback erhalten und melden uns zeitnah bei dir.": "k211",
  "Weitere Nachricht schreiben": "k212",
  "Deine Nachricht / Feedback *": "k213",
  "Was können wir verbessern, welche Funktion wünschst du dir oder wobei brauchst du Hilfe?": "k214",
  "E-Mail oder Telefonnummer für Rückfragen (optional)": "k215",
  "z. B. name@shop.de oder 0176 ...": "k216",
  "⏳ Wird gesendet…": "k217",
  "📨 Feedback direkt absenden": "k218",
  "Oder direkt per E-Mail schreiben:": "k219",
  "Feedback & Kontakt": "k220",
  "Wunsch, Idee oder Problem direkt an uns senden": "k221"
};

/**
 * Übersetzt statische tr(de, en, nl)-Aufrufe in alle 24 Sprachen über locales[lang].ui.tr.
 * Fällt sicher auf de/nl/en zurück, falls ein Schlüssel noch nicht vorhanden ist.
 */
export function makeTr(lang) {
  const l = lang || 'de';
  return (de, en, nl) => {
    const k = DE_TO_KEY[de];
    const hit = k && locales[l]?.ui?.tr?.[k];
    if (typeof hit === 'string' && hit.length > 0) return hit;
    return l === 'de' ? de : l === 'nl' ? (nl || en || de) : (en || de);
  };
}

/**
 * Übersetzt dynamische ui.tr.dXX-Schlüssel mit {{platzhaltern}} in alle 24 Sprachen.
 */
export function trDyn(lang, key, vars = {}, fallback = '') {
  const l = lang || 'de';
  const raw = locales[l]?.ui?.tr?.[key] || locales.en?.ui?.tr?.[key] || locales.de?.ui?.tr?.[key] || fallback;
  return String(raw).replace(/\{\{(\w+)\}\}/g, (m, k) => (vars[k] !== undefined ? vars[k] : m));
}
